import axios from 'axios';
import {
  AttributesApi,
  CriteriaApi,
  TrialManagementApi,
  ChatEntriesApi,
  DiseasesApi,
  ContactApi,
  ContactFormApi,
  LocationApi,
  UserTrialsApi,
  DependencyApi,
  DependencyProposalsApi,
  QuestionsApi,
  HospitalsApi,
  AuthApi,
  ConfigurationApi,
  InsightsApi,
  InviteApi,
  NotificationsApi,
  PermissionsApi,
  PreferencesApi,
  ProfileApi,
  TeamApi,
  TokenApi,
  UserApi,
  ConsentsApi,
  CategoryApi,
  DelayIndexApi,
  SurveyManagementApi,
  SurveyQuestionsApi,
  SurveyDependencyApi,
  UserSurveysApi,
  PanelManagementApi,
  UserPanelsApi,
  SponsorApi,
  ConversionApi,
  ConversionRuleApi,
  MilestoneApi,
  MilestoneAttachmentApi,
  MilestoneLinkApi,
  MilestoneTranslationApi,
  OriginalCriteriaApi,
  PredicateLibraryItemsApi,
  PredicatePipelineApi,
  PredicateQuestionsApi,
  PredicatesApi,
  ProjectionsApi,
  CohortsApi,
  PendingLocationChangeApi,
  MatchingEngineApi,
  ParityRoutingApi,
  ReportingApi,
  SliceReadinessApi,
  TiersApi,
} from '@data/sdk/match';
import { axiosInterceptors } from './axios-interceptors';

export const matchingApi = axiosInterceptors(
  axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL,
  }),
);

export const MatchingApi = {
  attributes: new AttributesApi({ isJsonMime: () => true }, undefined, matchingApi),
  category: new CategoryApi({ isJsonMime: () => true }, undefined, matchingApi),
  chat: new ChatEntriesApi({ isJsonMime: () => true }, undefined, matchingApi),
  contact: new ContactApi({ isJsonMime: () => true }, undefined, matchingApi),
  contactForm: new ContactFormApi({ isJsonMime: () => true }, undefined, matchingApi),
  criteria: new CriteriaApi({ isJsonMime: () => true }, undefined, matchingApi),
  dependency: new DependencyApi({ isJsonMime: () => true }, undefined, matchingApi),
  dependencyProposals: new DependencyProposalsApi(
    { isJsonMime: () => true },
    undefined,
    matchingApi,
  ),
  diseases: new DiseasesApi({ isJsonMime: () => true }, undefined, matchingApi),
  matchingEngine: new MatchingEngineApi({ isJsonMime: () => true }, undefined, matchingApi),
  parityRouting: new ParityRoutingApi({ isJsonMime: () => true }, undefined, matchingApi),
  reporting: new ReportingApi({ isJsonMime: () => true }, undefined, matchingApi),
  sliceReadiness: new SliceReadinessApi({ isJsonMime: () => true }, undefined, matchingApi),
  hospitals: new HospitalsApi({ isJsonMime: () => true }, undefined, matchingApi),
  insights: new InsightsApi({ isJsonMime: () => true }, undefined, matchingApi),
  location: new LocationApi({ isJsonMime: () => true }, undefined, matchingApi),
  questions: new QuestionsApi({ isJsonMime: () => true }, undefined, matchingApi),
  trialManagement: new TrialManagementApi({ isJsonMime: () => true }, undefined, matchingApi),
  userTrials: new UserTrialsApi({ isJsonMime: () => true }, undefined, matchingApi),
  userSurveys: new UserSurveysApi({ isJsonMime: () => true }, undefined, matchingApi),
  userPanels: new UserPanelsApi({ isJsonMime: () => true }, undefined, matchingApi),
  auth: new AuthApi({ isJsonMime: () => true }, undefined, matchingApi),
  configurations: new ConfigurationApi({ isJsonMime: () => true }, undefined, matchingApi),
  invites: new InviteApi({ isJsonMime: () => true }, undefined, matchingApi),
  notifications: new NotificationsApi({ isJsonMime: () => true }, undefined, matchingApi),
  permissions: new PermissionsApi({ isJsonMime: () => true }, undefined, matchingApi),
  preferences: new PreferencesApi({ isJsonMime: () => true }, undefined, matchingApi),
  profile: new ProfileApi({ isJsonMime: () => true }, undefined, matchingApi),
  token: new TokenApi({ isJsonMime: () => true }, undefined, matchingApi),
  user: new UserApi({ isJsonMime: () => true }, undefined, matchingApi),
  consents: new ConsentsApi({ isJsonMime: () => true }, undefined, matchingApi),
  team: new TeamApi({ isJsonMime: () => true }, undefined, matchingApi),
  delayIndex: new DelayIndexApi({ isJsonMime: () => true }, undefined, matchingApi),
  surveyManagement: new SurveyManagementApi({ isJsonMime: () => true }, undefined, matchingApi),
  surveyQuestions: new SurveyQuestionsApi({ isJsonMime: () => true }, undefined, matchingApi),
  surveyQuestionDependencies: new SurveyDependencyApi(
    { isJsonMime: () => true },
    undefined,
    matchingApi,
  ),
  panelManagement: new PanelManagementApi({ isJsonMime: () => true }, undefined, matchingApi),
  pendingLocationChange: new PendingLocationChangeApi(
    { isJsonMime: () => true },
    undefined,
    matchingApi,
  ),
  sponsor: new SponsorApi({ isJsonMime: () => true }, undefined, matchingApi),
  conversion: new ConversionApi({ isJsonMime: () => true }, undefined, matchingApi),
  conversionRule: new ConversionRuleApi({ isJsonMime: () => true }, undefined, matchingApi),
  milestone: new MilestoneApi({ isJsonMime: () => true }, undefined, matchingApi),
  milestoneAttachment: new MilestoneAttachmentApi(
    { isJsonMime: () => true },
    undefined,
    matchingApi,
  ),
  milestoneLink: new MilestoneLinkApi({ isJsonMime: () => true }, undefined, matchingApi),
  milestoneTranslation: new MilestoneTranslationApi(
    { isJsonMime: () => true },
    undefined,
    matchingApi,
  ),
  originalCriteria: new OriginalCriteriaApi({ isJsonMime: () => true }, undefined, matchingApi),
  predicateLibraryItems: new PredicateLibraryItemsApi(
    { isJsonMime: () => true },
    undefined,
    matchingApi,
  ),
  predicatePipeline: new PredicatePipelineApi({ isJsonMime: () => true }, undefined, matchingApi),
  predicateQuestions: new PredicateQuestionsApi({ isJsonMime: () => true }, undefined, matchingApi),
  predicates: new PredicatesApi({ isJsonMime: () => true }, undefined, matchingApi),
  projections: new ProjectionsApi({ isJsonMime: () => true }, undefined, matchingApi),
  cohorts: new CohortsApi({ isJsonMime: () => true }, undefined, matchingApi),
  tiers: new TiersApi({ isJsonMime: () => true }, undefined, matchingApi),
};
